import React, { useState } from 'react';
import {
  TickOneIcon,
  DynamicFacebookIcon,
  DynamicInstaIcon,
  DynamicTickIcon,
} from '../../atoms/icons';
import CustomPaging from './image-slider';
import { redirectToProductDetails } from '../../../utils';
import NoImage from '../../../assets/images/no-image.png';
import defaultAvatar from '../../../assets/images/default-avatar.jpg';
import VideoCustomPaging from './video-slider';

export const TemplateThree = ({
  expertiseData,
  preferredBrands,
  preferredProducts,
  redirectToBuyerPortal,
  redirectToShopPortal,
  cardDetails,
  schedulerEnabled,
}) => {
  const { seller, storefront } = cardDetails?.current?.config;
  const LogoUrl =
    storefront?.general?.longLogoImage?.url ||
    storefront?.general?.logoImage?.url ||
    null;

  const [isExpanded, setIsExpanded] = useState(false);
  const toggleReadMore = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      <div className="three-wrapper">
        <section className="three_header">
          <div className="wrapper-one">
            <header className="flex justify-between items-center gap-6">
              {LogoUrl ? (
                <div className="logo-box max-w-56">
                  <img src={LogoUrl} alt="logo" />
                </div>
              ) : (
                <h2 className="logo-text pl-1 capitalize text-threePrimary">
                  {storefront?.general?.name}
                </h2>
              )}
            </header>
          </div>
        </section>
        <section className="three-body">
          <div className="left-box">
            <div className="profile-box">
              <img
                src={
                  seller?.profile?.avatar?.mediumUrl ||
                  seller?.profile?.avatar?.url ||
                  defaultAvatar
                }
                alt="icon"
                onError={(e) => {
                  e.target.onerror = null;
                  e.target.src = defaultAvatar;
                }}
              />
            </div>
            <div className="three-view">
              <h2 className="text-white-main font-bold md:text-5xl text-4xl font-tempOne capitalize break-words">
                {seller?.profile?.title}
              </h2>
              <div className="boder-line border-threePrimary"></div>
              <div className="long-text">
                <div
                  className={
                    isExpanded
                      ? 'full-text'
                      : seller?.profile?.about?.length > 600
                      ? 'clamped-text'
                      : ''
                  }
                >
                  <p
                    className="font-bold text-xl mt-5 font-tempOne after:border-threePrimary"
                    dangerouslySetInnerHTML={{
                      __html: seller?.profile?.about,
                    }}
                  />
                </div>
                {seller?.profile?.about?.length > 600 && (
                  <div className="text-right">
                    <button
                      className="text-threePrimary read-text"
                      onClick={toggleReadMore}
                    >
                      {isExpanded ? 'Read Less' : 'Read More'}
                    </button>
                  </div>
                )}
              </div>
            </div>
            <div className="social-icon">
              {seller?.profile?.facebookUrl && (
                <a
                  href={seller?.profile?.facebookUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DynamicFacebookIcon className="text-threePrimary" />
                </a>
              )}
              {seller?.profile?.instagramUrl && (
                <a
                  href={seller?.profile?.instagramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DynamicInstaIcon className="text-threePrimary" />
                </a>
              )}
              {seller?.profile?.tiktokUrl && (
                <a
                  href={seller?.profile?.tiktokUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <DynamicTickIcon className="text-threePrimary" />
                </a>
              )}
            </div>
            <div className="box-wrp">
              <button
                className="text-white-main font-bold text-xl mt-10 px-10 py-4 rounded-ThreeCustom bg-threePrimary border border-white-main"
                onClick={() =>
                  redirectToShopPortal(storefront?.general?.shopUrl)
                }
              >
                Shop the store
              </button>
            </div>
          </div>
          <div className="right-box">
            {seller?.profile?.galleryImages?.length ? (
              <>
                <h2 className="text-white-main font-semibold text-2xl font-tempOne mb-5 md:text-left text-center">
                  Salon Gallery
                </h2>
                <div className="three-salon-gallery  md:mx-0 -mx-4">
                  <CustomPaging images={seller?.profile?.galleryImages} />
                </div>
              </>
            ) : (
              <></>
            )}
            {seller?.profile?.galleryVideoLinks?.length ? (
              <>
                <h2 className="text-white-main font-semibold text-2xl font-tempOne mb-5 mt-5 md:text-left text-center">
                  Salon Videos
                </h2>
                <div className="three-salon-gallery  md:mx-0 -mx-4">
                  <VideoCustomPaging
                    videos={seller?.profile?.galleryVideoLinks}
                  />
                </div>
              </>
            ) : (
              <></>
            )}

            <div>
              {expertiseData?.length ? (
                <div
                  className={
                    expertiseData?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <h2 className="text-white-main font-semibold text-2xl font-tempOne mt-7 mb-5 text-center md:text-left">
                    Expertise
                  </h2>
                  <ul>
                    {expertiseData?.map((item, index) => (
                      <li key={index} className="flex items-center mb-2">
                        <TickOneIcon className="text-threePrimary" />
                        <span className="ml-2.5 font-normal md:text-base text-sm text-white-main">
                          {item?.name}
                        </span>
                      </li>
                    ))}
                  </ul>
                </div>
              ) : (
                <div
                  className={
                    seller?.profile?.expertise
                      ? 'visibility-auto'
                      : 'visibility-hidden'
                  }
                >
                  <h2 className="text-white-main font-semibold text-2xl font-tempOne mt-7 mb-5 text-center md:text-left">
                    Expertise
                  </h2>
                  <p
                    className="mt-5 font-tempOne border-onePrimary text-white-main"
                    dangerouslySetInnerHTML={{
                      __html: seller?.profile?.expertise,
                    }}
                  />
                </div>
              )}
              {schedulerEnabled && (
                <div className="text-center mt-6">
                  <button
                    className="text-white-main font-bold text-xl px-10 py-4 rounded-ThreeCustom bg-threePrimary border border-white-main"
                    onClick={() => redirectToBuyerPortal()}
                  >
                    Book an appointment
                  </button>
                </div>
              )}
            </div>
            <div>
              {preferredProducts?.length ? (
                <div
                  className={
                    preferredProducts?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <h2 className="text-white-main font-semibold text-2xl font-tempOne mt-7 mb-5 md:text-left text-center">
                    My Favorite Products
                  </h2>
                  <div className="flex md:gap-4 gap-2 flex-wrap justify-center md:justify-start">
                    {preferredProducts?.slice(0, 4).map((product, index) => (
                      <div
                        key={index}
                        className="image-wrp cursor-pointer"
                        onClick={() =>
                          redirectToProductDetails(
                            storefront?.general?.shopUrl +
                              '/products/' +
                              product?.slug
                          )
                        }
                      >
                        <img
                          src={
                            product?.primaryImage?.mediumUrl ||
                            product?.primaryImage?.thumbUrl ||
                            NoImage
                          }
                          alt={`Product ${index + 1}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : preferredBrands?.length ? (
                <div
                  className={
                    preferredBrands?.length === 0
                      ? 'visibility-hidden'
                      : 'visibility-auto'
                  }
                >
                  <h2 className="text-white-main font-semibold text-2xl font-tempOne mt-7 mb-5 md:text-left text-center">
                    My Favorite Brands
                  </h2>
                  <div className="flex md:gap-4 gap-2 flex-wrap justify-center md:justify-start">
                    {preferredBrands?.slice(0, 4).map((product, index) => (
                      <div
                        key={index}
                        className="image-wrp cursor-pointer"
                        onClick={() =>
                          redirectToProductDetails(
                            storefront?.general?.shopUrl +
                              '/brands/' +
                              product?.slug
                          )
                        }
                      >
                        <img
                          src={
                            product?.coverImage?.mediumUrl ||
                            product?.coverImage?.thumbUrl ||
                            NoImage
                          }
                          alt={`Product ${index + 1}`}
                        />
                      </div>
                    ))}
                  </div>
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};
